/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Ejemplar', Ejemplar);

    /* @ngInject */
    function Ejemplar($resource) {
        return $resource('api/admin/ejemplar/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/ejemplar/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/ejemplar/filterByEdicion'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/findUsedLetters'
            },
            'findEjemplaresDTOByEdicion': {
                method: 'GET',
                isArray: true,
                url: 'api/public/ejemplar/findEjemplaresDTOByEdicion'
            },
            'findEjemplaresByCreador': {
                method: 'GET',
                url: 'api/admin/ejemplar/findEjemplaresByCreador/:login'
            }
        });
    }
})();
